import { FormFieldBase } from './form-field-base.model';

export class FormFieldTextbox extends FormFieldBase<string> {
  override controlType = 'textbox';
}
